export default {
    isInInstagramApp() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /Instagram/.test(userAgent);
    },
}